<template>
  <v-dialog persistent v-model="activeModal" max-width="800">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="headline">{{ title }}</span>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text>
        <GrupoForm
          :is-edit-mode="true"
          :initial-data="grupoData"
          @save="handleSave"
          @cancel="close"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import GrupoForm from "../../../components/forms/GrupoForm.vue";

export default {
  name: "EditarGrupoModal",
  components: {
    GrupoForm
  },
  props: {
    activeModal: {
      type: Boolean,
      default: false
    },
    grupo: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: "Editar Grupo"
    }
  },
  computed: {
    grupoData() {
      // Mapeia os dados para o formato esperado pelo GrupoForm
      return {
        id: this.grupo.id,
        exercicio: this.grupo.exercicio?.ano || this.grupo.exercicio || '',
        codigo_grupo: this.grupo.codigo_grupo || '',
        descricao: this.grupo.descricao || '',
        ativo: this.grupo.ativo !== undefined ? this.grupo.ativo : true
      };
    }
  },
  methods: {
    async handleSave(formData) {
      try {
        // Emite evento para o componente pai com os dados atualizados
        this.$emit('grupo-atualizado', {
          ...formData,
          id: this.grupo.id
        });
        
        // Fecha o modal
        this.close();
      } catch (error) {
        console.error('Erro ao atualizar grupo:', error);
        throw error;
      }
    },

    close() {
      this.$emit('update:activeModal', false);
    }
  }
};
</script>

<style scoped>
.v-dialog {
  border-radius: 12px;
}

.v-card {
  border-radius: 12px;
}

.v-card-title {
  background-color: #F8FAFC;
  border-bottom: 1px solid #E5E7EB;
  padding: 20px 24px;
}

.headline {
  color: #1F2937;
  font-size: 1.5rem;
  font-weight: 700;
}
</style>